webpackJsonp([172941072185112],{

/***/ 1587:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _CheckboxGroup = __webpack_require__(17);
	
	var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _ResponsiveVid = __webpack_require__(21);
	
	var _ResponsiveVid2 = _interopRequireDefault(_ResponsiveVid);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Datetime = __webpack_require__(18);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Formweb = function (_Component) {
	  _inherits(Formweb, _Component);
	
	  function Formweb(props) {
	    _classCallCheck(this, Formweb);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  Formweb.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "700px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              type: "heading3",
	              gutterBottom: true,
	              style: { color: "#f15623" }
	            },
	            "Fantastic!"
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading5", gutterTop: true },
	            "We\u2019ll reach out to you asap via email or telephone.",
	            _react2.default.createElement("br", null)
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          mls_number: "",
	          form: "website_form",
	          list: 89671,
	          meetingdate: "",
	          meetingtime: "",
	          role: "",
	          interests: ""
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            mls_number: Yup.string()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          //if (values.meetingdate != undefined) {
	          var meeting_request = "";
	          var notes = "Interests: ";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	            if (key == "roleOther") {
	              if (values.roleOther.length > 0) {
	                values.role = values.roleOther;
	              }
	            }
	            if (key == "interestsOther") {
	              if (values.interestsOther.length > 0) {
	                //notes = values.interests.join(",");
	                notes = notes + "," + values.interestsOther;
	              }
	            }
	            if (key == "interests") {
	              if (values.interests.length > 0) {
	                notes = notes + "," + values.interests.join(",");
	              }
	            }
	          });
	
	          var body = _extends({}, values, {
	            notes: notes,
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            demo_request_date: meeting_request
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "bright");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement(
	              "div",
	              { style: { marginBottom: "30px" } },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: classes.headingLarge,
	                  style: { marginBottom: "25px" }
	                },
	                "Get a stunning IDX website,",
	                _react2.default.createElement("br", null),
	                "starting as low as $150/m."
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    color: "#495050",
	                    lineHeight: "22px",
	                    paddingBottom: "35px"
	                  }
	                },
	                "Get a stunning IDX website, starting as low as $150/m. All Elevate IDX websites come with a full CRM, social media, email and text marketing, and fanatical training and support... starting as low as $150/m. Watch our quick video and then schedule",
	                _react2.default.createElement("br", null),
	                "your 15-minute demo TODAY to learn more."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: classes.fullWidthVid },
	                _react2.default.createElement(
	                  "div",
	                  { aspectRatio: "16by9" },
	                  _react2.default.createElement(_ResponsiveVid2.default, { youtubeId: "xPJyb2d_tnU" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxWidth: "500px",
	                  marginLeft: "auto",
	                  marginRight: "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "firstname",
	                  name: "firstname",
	                  label: "First Name",
	                  component: _Input2.default,
	                  className: classes.field
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "lastname",
	                  name: "lastname",
	                  label: "Last Name",
	                  component: _Input2.default,
	                  className: classes.field
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "email",
	                name: "email",
	                label: "Email",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "phone",
	                name: "phone",
	                label: "Phone",
	                component: _Input2.default,
	                className: classes.field,
	                type: "tel"
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "company",
	                name: "company",
	                label: "Affiliation (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "mls_number",
	                name: "mls_number",
	                label: "MLS # (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "role",
	                name: "role",
	                label: "I am a(n)  \xA0\xA0(optional)",
	                component: _RadioGroup2.default,
	                display: "inline",
	                items: [{
	                  label: "Agent",
	                  value: "Agent"
	                }, {
	                  label: "Team",
	                  value: "Team"
	                }, {
	                  label: "Broker",
	                  value: "Broker"
	                }, {
	                  label: "Other (please specify)*",
	                  value: "Other"
	                }],
	                className: classes.field
	              }),
	              values.role === "Other" && _react2.default.createElement(_formik.Field, {
	                id: "roleOther",
	                name: "roleOther",
	                label: "Other",
	                component: _Input2.default,
	                className: classes.field,
	                autoFocus: true
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "interests",
	                name: "interests",
	                label: "I am interested in:  (select all that apply)",
	                component: _CheckboxGroup2.default,
	                items: [{
	                  label: "Digital Marketing Services (Website, Email, Social, etc.)",
	                  value: "Digital Marketing Services (Website, Email, Social, etc.)"
	                }, {
	                  label: "Lead Generation, Parsing & Scrubbing Services",
	                  value: "Lead Generation, Parsing & Scrubbing Services"
	                }, {
	                  label: "CRM Solutions",
	                  value: "CRM Solutions"
	                }, {
	                  label: "Custom Creative / Marketing Services",
	                  value: "Custom Creative / Marketing Services"
	                }],
	                className: classes.field
	              }),
	              console.log(values.interests),
	              values.interests.includes("Other") && _react2.default.createElement(_formik.Field, {
	                id: "interestsOther",
	                name: "interestsOther",
	                label: "Other",
	                component: _Input2.default,
	                className: classes.field,
	                autoFocus: true
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "submit",
	                  className: classes.signUpBtn,
	                  disabled: isSubmitting
	                },
	                "let's connect"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "11px", paddingBottom: "35px" } },
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means.",
	              _react2.default.createElement("br", null),
	              "Existing subscribers seeking support, please visit the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://support.tryelevate.com/s/ " },
	                "Elevate Help Center"
	              ),
	              "."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return Formweb;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _fullWidthVid;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "700px",
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    headingSmall: {
	      fontSize: "20px",
	      textTransform: "uppercase",
	      fontWeight: "600",
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingLarge: {
	      fontSize: "33px",
	      fontWeight: "700",
	      color: "#5bc0b8",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "38px"
	    },
	    headingText: {
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "1.4em"
	    },
	    checkfield: {
	      width: "20px",
	      height: "20px",
	      position: "relative",
	      top: "4px",
	      marginLeft: "10px"
	    },
	    signUpBtn: {
	      width: "60%",
	      fontSize: "18px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: "#5bc0b8",
	      borderRadius: "6px",
	      padding: "12px",
	      marginTop: "30px",
	      marginBottom: "30px",
	      textDecoration: "none"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    },
	
	    fullWidthVid: (_fullWidthVid = {
	      width: "100%",
	      marginLeft: "auto",
	      marginRight: "auto"
	    }, _fullWidthVid[theme.breakpoints[900]] = {
	      width: "75%"
	    }, _fullWidthVid)
	  };
	})(Formweb);
	module.exports = exports["default"];

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dms_bottom_image.9a334540.jpg";

/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMzaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzMiA3OS4xNTkyODQsIDIwMTYvMDQvMTktMTM6MTM6NDAgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjFCRUVFQ0UxMzFCRDExRUFCRDBEOTM0NkVERDQ1QTg3IiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjFCRUVFQ0UwMzFCRDExRUFCRDBEOTM0NkVERDQ1QTg3IiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE1LjUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5QjE5MkU0NTNENjUxMUU5OTNGN0E0QzRDODI4MzVEMSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QjE5MkU0NjNENjUxMUU5OTNGN0E0QzRDODI4MzVEMSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uAA5BZG9iZQBkwAAAAAH/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAgICAgICAgICAgMDAwMDAwMDAwMBAQEBAQEBAgEBAgICAQICAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDA//AABEIADoDhAMBEQACEQEDEQH/xACNAAEBAQEBAQEBAAAAAAAAAAAAAQIDBAYFCgEBAQEBAQEAAAAAAAAAAAAAAAECAwUGEAABAQMICAUCBwACAwEAAAABABECFDFRYZGh0RIE8CFBcYHhUhOxwWKSotID8SIyQoKy4nLC8lMFFREBAAIDAQACAwEAAwAAAAAAABESAWECEzFRIUEikXGxkv/aAAwDAQACEQMRAD8A/ryGTJ2VAXBeu+TziG4STUfUb5kI/wASDMm9vNCMpB7Ga2zOt3SoRlzOU1SG3koZxGHM5UzCX3Vrd+mWIaiz/KX6HOG1ya7fFL9DBypm8G+BS/QwcqZrDyCX6GTlpxrp/FL9EMnLUapgw66lr00QkN6fPwdT00Qycr6T5Val0RIUiQVA+a5+mlhRlTsFhPmV0RIb0PVrn6aWGob02f5T00QQ3ps/ynpohYUzCsXJ6aIWFE1jqemiGhlf3AcGJ6aIbhDoHl0QhDoHkEhToHlxv0rUK96agl+hmDd6fG5ZVYQCQG25W2cfhCFoNtyt+ghaDbcmO8/sIWg1m5a9NEEKJjWbk9NEJCnZ/wBlnPef0EKdA8l+ghToHlLZz+AhDoHlFIQ6B5BIUjYTwPmVcdZx8IQpEjpq5q36CFPSRw5pfoIUysaaAfMhL9CQh6bOaX6AZWVgZwPkVM5zn5VqEOgeUCEOgeQSGPSbb10vpIIY9JtvT00QQx6TbenpoghfRZzT00QkJ6SOA82p6aISEoNTqemiEhZh/XmnpoghaP6q89TmBYQaB1bQhJh/UXoMwrzZHbFjPcZiFIVuy0DwCnpohIZmw1kjwYnpohYSj5M8AnpohIZv7fL/AKp6aIIWg1m5PTRCQomNZuT00QsKJjbcnpohIWX8pZsl5p6aIQZXXrBZrT00QpyswPHEnpohIUzWPJ6aIIUzWPJfRCwh0Dy6I8uZyn6NXVs3dSDxnLCaz/JCzfkiPhk5UzN3AjzCX5ViFHSLL1pGTlWbPC5BIZmzdPaEFGVPSOJduKkz8CjLhjLKDUk4+8K2MsJt0uvXx2qX5HUZagUb5NjEvyNDLBkjPOhg2lL8jQyknmCJLEvyNwtAsuS/IoynpaN3jIxaRRlWftAlPnQs35VqE1ya2Naw7p2rSLC6MeWb8qQtDKGPeSX5EhTNY8s+miGoUTG25avyEKZh7StIgytHjcVz9NLDUKdoHt5FdEISh2aR39My5+mlghTMKxcnpoh1hTNr02Yl0RkZU9JOv8ZNq5+mlhqFM1jyemiGoWi2ncnpohqF9I1bte+ZPTRCw3gzZes36G4QmUWFL9DQytFfMJfohoZUnZroDpS/Q1CHps5pfoahDoHllVhBMbbkCFoNty1fpCFoNtyX6+1hYXazTcxL9IkLQW8WeCX6GYV7pNXNL9DmctRYPIFL9DnDFsmts1rGzJfpY/b7x3KTu1/lFQ1LDo6wfpZwl/sgQWmHkghybG6rAxBzOTorLRxQYOT2kTMxHzdRI/bkcpNJuPkiuT2SZI6GVeIRIwwclRaTVtQjDByYIZgI8kIwycjNtoYfAJKVYeyc3h9KSVYgqBNI9JMklQ5ITD2lDOP2kCekz/p2T/8AG1JKrBCYe0pJUghMPaUkqsHox6X8UkqoyJOzxEu3XO1JKtDIlkjfCvWQklWoH0ln/F1JKtwQ2us3uvIsYIEdIbuPhKhGGoKg1H1HXIhGCCE3yQjBBibY2V6qSVCMEEJvkhGCCE3yQjBBCb5IRhYOj5IRgg6BWLkIwQTZHfkhGCCo+SEYSCE3yQjCwVHyQjCHJs2Wk+EiEYIMTfIjxQjDMCOkVE+CEYSCHSKnkIwQQ6RUUIw1A7Q6ANkvJCMEFtYN7C3xahGEgRM0nZhb4FqEYaGROx1nB4eaEYZgRtdZ/F7khGEgWTHhckpUggf2s3i5JKocizY3cAklUgvSagixggvSaghGCC9JqCEYIL0moIRggvSaghGCC9JqCEYIL0moIRhYAysPs5JKVZgnumwXJJUgnumwXJJUORMxqA8EkqkCek1lJKhyOraN+seISSpA6tu9mr+ySVQZFrZTuHj+YpJUgH5vG9JKpAvCVlt6SVZOSnDeBN6ER9kGJrCh/pBiawof6QYmsKH+vNmcl+hgP7pB/wAZ1cdZx8JnEvGck9MeJWr9MsHJmjadU8+9L9DnB+ks3CU/il+hg5Mtk3NlGpL9DMHQPaUv0LCMkDODy16aIbdybzJNWxgCzfobgiJRYD/VL9DqMm906VFL9Do7kjNM3ZLsbJKsq3AyHC0z3SoOgyJMgrACix9NQJmd04qkZX/897oFXNCMrAyFmrRmzUxSVqQJm1b/AHbdaqRkgqJPVw1IRkgZdVEth1oRlo5Fmw8Sy9SVrhDkhMaWmdPyn8kCTK6djNGhUjKwBmq1CoNCkrVYCh7TiklVgjMfaEkqsDQJek1SSJKVysD6Q2bCW7t6StWxkaJtbDqdl16/ypJVRkZdgkF29JKqMk3ZU6CGs37Ukq3BCYe0pJVsZEBv5WcWbgaUWMKMk3UyX1TIRhoZKd1nBvgEIw1BDpFTyEYagqHdOKK3BendRIgoyMjQfEIkfZBUPacUVIKTUdJd7ESMJBUf+FfJFZOSO0Bu4lBxeyXpr1WCVEjDnBDF+nU2bVXKhGH3gylDa/8AyRXYZVokNvk1Ag3enxuUnAy9lHenXP8AixUZOUoZQQB460HI5QbXWa5Tr8EGHslqZ5DXa6g5PZLXJUw1oMPZRn7bJfFByOTbssPm1BIIzf0vQSDMxqCCQNBlpr3IJBTgjj+CBB69Qbx/FBYKh7TigQVD2nFAgqHtOKDUFph5INwQ6RWLkFg6PkgruTbsNR80GoNsgNTqBBGYVH6EFgtMPJAhPxZ/JqBB0benZdaghygGrCKrygQo6RZegQgOoOjgBegoydFbtyAcnRU7egQWmHkgQWmHkgQWmHkgQWmHkgQWmHkgQWmHkgQWmHkgHJaM5IIMmTsZwB8AgsFph5IMjJk7KgD5BBYMzGoIEGZjUEEgTNa99KBAma176UEgTM3ifMBAgj0ms3IEEek1m5BYKh7TigQVD2nFAgWyuvacUEgB0moXoEAOk1C9BID0aVIEB6NKkCA9GlSDMGzYODfJBYEj9oGm9BmDoFRQIMTCooEGOkVFBqCHSKxcgQQ6RWLkEORmAFRQSBNFiBA7qggkFph5IPP9/Itw/wAtjJqEHlgfS9pxRIw5nIUDeQzzIQj7YP8A86gNpP4oORyBlIGuhiSlcJAuzDXQb/y6kWMEDQ7pxSUrhsf/AD2/sZvPJJK4bGRbsIMuuSpF+XZ3Izhm5vNFdhkdckkw1+IQaGRZ+0jdoEHQZFmsW89agsEJMI02tYxUIKh3Tig1Aen4/wCkFgB0moXoEEegVD6UEgPRpUgsEegVD6UEgPRpUgQHo0qQagXf/XYfqQSCErDNoWsY1BqBadQImaWWtQWA0agDIndvw80FgxMKig3AejSpBqCoe04osZ+lGTo1Uhto1oiwWmHkg0Mlqbh1bjzQahHfVUUGoQaB1BYIzCo/Qg3BUO6cVJwEG5M77gqEL6Xq0Fgh0isXIJBUO6cUGDktjDwA8QoOT2Sbsnl8x+oa1Rygxj/RrbZVKxB9Y79ijfrb4ayq7urv2KNKC8g12aP63LEpTlD9luw1XMWkryw99jVIamWlVpg/YbNpwasSlOXN7LjaN229ahim2Xvs8KwSkFNsn7AEobO0g/2CQU2h+wCP0jjhZ4JBTbPYPSPcUgpshnekacVJwvnshnZhVzScM06Yhj02f5ScLHH2Q4ms/wApOEp03DO9I04pOGvPZDO9I04pODz2Q7JHRWzzScHntrsDpPuCsJTZ2R0/1uWZXz2Q40eNyv8ARTaQ+61P6Kbb7AmFn0qwlNtw7vT8TeiV6SHM59pvSFptIYdAqNyroQw6fib1n+hYYdFhV/5Yz8/ohh0WG5E/8kMOiwouPn9EM70/E3qtkM70/E3oEO70/E3qMZ5nMrDu9PxKQlNkO70spYdSQU2nZE5sSCmzsic2JBTaj7Dp2NpY3wRM8Z/RDu9PxN6FeiHd6fib0K9L2BManr0K9HYExqevQr0y9l2sYCZf23lCvTEOen4i9CvRDnp+PNCvSwpneqe+pV1IU9T1T31IJDkfuPHEPMqM9c2Oweq169IZps7B6rXr0gps7ImbTq1160gps7I6f63JBTYPsA/t8PIFPgptewJhp/FScL57YP2A2TSsJODz2Q+629PyU2Q+61P6KbWHFFZT+imyHGjxuT+imyHGjxuT+im0OWmLKNAp/RTaQ3q0qSOim1hqW0GQ2FWOkosO70uafwVSvRDu9Lmn8EK9EM70u1s8HEK9JCu9LtZ+hCvRDO9LvAn6UK9LDuzGtCvTl93LAgECRrdsrKCxTP4+UzjOPlwOVdpqZ4BVa9MnJuy4RWByUnCZxnHy5nJekjc02FhVRzOUdOwneDcUar0kEJndOKFelg3enxuRlqDdGwjcLkGhlANjd7L0HUZV0bDuYQLCjVenR3KAj9IO7F5hqk4WOPtuF9L1aThhqFpHtF6ThqnRD+h2tSWvPbUM70jTirODz2xD+mz/ACk4PPaw7sx9vJJwee2oZ3pGnFJweeyGd6RpxScHnshnekacUnB57Oweke4pODz2dg9I9xScHns7B6R7kjGimzsHpHuKTg89pD6pNMOmmpWEptYZ2Ye165IKbah3egVOXJCUykN6tKlIy1TY7lhN52fmVnDbUO90/EJDnTbpDu9PxKQU2x2Hel21V0ah3tHhcsSx57bh6Lf9LUJTbPYdmetScOiw4mPuClhvsO9I9zyksee07Am/rcn8tVwp+wDKB43hbVe2em3mozXk7I0eeQrywfsTAWclLLjnGPhD9j0trPg1WGKbcocNk1zM1yt32rMr57fshw7Ayk6NUdG+3TZzQO3TZzQO3TZzQZwPUHSlBkuEyu66NdoRIx9M4HZrTeipgFNlyDPaFHtCC9p3QC9RiM/WGe2fTVyVnK05O3Q7pwWrKdqh3Tgsqdqh3Tggdqh3Tggduh2rkrOQ7dDunBWyL2zM7VyUlKcnbFHtCyV5aweo1c0SM/WGe0KPaFWztCj2hBe3TZzQXAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkDAKbLkE7Ts3hcgdpybwuQTtO7PAckDtCj2hA7Qo9oQO0KPaEDtCj2hA7Qo9oQO0KPaEDtCj2hA7Qo9oQO0KPaEDtCj2hA7Qo9oQO0KPaEFH22SFnDmiZxjPyYD1Wc1EryYD1Wc0K8mA9VnNCvKH7ZNNnmtcleWOyOgV81lI1/wBM9odJqFy6FeWT9kbdX8WearSdkU23qM/zpzP2BMODPPWq0vZHQLL1Ga8r2KbeSrTqPsUWDzagD7RmNgsXJK8t9kTmvktWP60vaod04KNHaod04IHbod04LVkOy7o29ScqdoT6VqTlmnK9sUe0JOSnK4D1Wc1CvKdsUe0KzkpynZd0berOWl7Yo9oUnLNOVwHqs5pOSnJ23dALknJTkwHqs5qFeVwCc2XIV5Tt02c1Wk7Qo9oQO0KPaEGsApsuQMApsuQMApsuQXAJpdNSBgdmtN6DWD0/HkgYPT8eSAHCJHddOq0okY+l7Z6RYhGPo7Z6RYhGPo7Z6RYhGPpcD01ovRU7Z6RYiRj6C6dobwahGPpkuDa6yxFZwCmy5B60BAQEBAQEEYJhUEEwOzWm9AwOzWm9AwOzWm9AwOzWm9AwOzWm9BMLts9iAHHd/G5BcDs1pvQMDs1pvQMDs1pvQMDs1pvQVgmFQQGCYVBAYJhUEBgmFQQGCYVBAYLW8UFQEEYJhUgMEwqCAwTCpBUBAQEBAQEBAQEEYJhUEBgmFQQGCYVBAYJhUEBgmFQQGCYVBAYJhUEBgmFQQGCYVBAYJhUEBgmFQQGCYVBAYJhUEBgmFQQGCYVBAYJhUEBgmFQQGCYVBAYJhUEBgmFQQGCYVBAYJhUEDCJhUgmB2a03oGB2a03oGB2a03oGB2a03oGB2a03oGB2a03oIXBs1W+aCdumzmgdumzmgmA0W3IGA0W3IM9s9IsRIx9HbPSLEIx9KHDMBpQir2ztI8bkFwDaTwH4oLgFNlyBgFNlyC4HZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegYHZrTegrBMKggjAJANKdZQaQEBAQEBAQEBAQEBAQRgmFQQVAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBB//9k="

/***/ }),

/***/ 1744:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Formweb = __webpack_require__(1587);
	
	var _Formweb2 = _interopRequireDefault(_Formweb);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _dms_top_image = __webpack_require__(1340);
	
	var _dms_top_image2 = _interopRequireDefault(_dms_top_image);
	
	var _dms_bottom_image = __webpack_require__(1339);
	
	var _dms_bottom_image2 = _interopRequireDefault(_dms_bottom_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Website = function Website(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Your Single Source Solution - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Your Single Source Solution - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "website", customTitle: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: "900px", backgroundColor: "#e9f1f3", marginRight: "auto", marginLeft: "auto" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.landingHeaderStyle },
	            _react2.default.createElement("img", { src: _dms_top_image2.default, style: { width: "100%" } })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingLeft: "10px", paddingRight: "10px" } },
	            _react2.default.createElement(_Formweb2.default, null)
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("img", { src: _dms_bottom_image2.default, style: { width: "100%" } })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      margin: "70px auto"
	    },
	    heading: {
	      fontSize: "28px",
	      fontWeight: "800",
	      letterSpacing: ".14px",
	      color: "#2E2E35",
	      textAlign: "center",
	      marginBottom: "12px"
	    },
	
	    subHeading: {
	      fontSize: "18px",
	      lineHeight: "28px",
	      letterSpacing: ".08px",
	      textAlign: "center",
	      margin: "0 auto 36px"
	    },
	    landingHeaderStyle: {
	      textAlign: "center"
	    }
	  };
	})(Website);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-website-js-9769d9addfcc4ecc35e8.js